import { atom } from 'recoil';

export const statusAtom = atom({
  key: 'statusAtom',
  default: 0,
});
